import React from 'react'
import {Flex, DotPagination, DotNavigation} from '/app/src/component'
import { connect } from 'react-redux'
import TutorialModel from '/app/src/model/Tutorial/model';

class Customization extends React.Component
{
    constructor(props) {
        super(props);

        this.state = {
            activePage: 1,
            pages: 3
        }

        this.nextButton = this.nextButton.bind(this);
        this.backButton = this.backButton.bind(this);
        this.finishButton = this.finishButton.bind(this);
        this._renderScreen = this._renderScreen.bind(this);
    }

    nextButton(){
        this.setState({
            activePage: this.state.activePage + 1
        })
    }

    backButton(){
        this.setState({
            activePage: this.state.activePage - 1
        })
    }

    finishButton(e){
        this.props.dispatch(TutorialModel.setToDone(this.props.listId, this.props.itemId))
        this.props.closeModal(e);
    }

    _renderScreen(activePage){
        switch(activePage){
            case 1:
                return this._screen1()
            case 2:
                return this._screen2()
            case 3:
            default:
                return this._screen3()
        }
    }

    _screen1(){
        return(
            <Flex>
                Screen 1
            </Flex>
        )
    }

    _screen2(){
        return(
            <Flex>
                Screen 2
            </Flex>
        )
    }

    _screen3(){
        return(
            <Flex>
                Screen 3
            </Flex>
        )
    }

    render(){
        return(
            <Flex grow column hAlignContent='center'>
                <Flex vAlignContent='center'>
                    <DotPagination pages={this.state.pages} activePage={this.state.activePage}/>
                </Flex>
                <Flex grow center>
                    {this._renderScreen(this.state.activePage)}
                </Flex>
                <DotNavigation
                    pages={this.state.pages}
                    activePage={this.state.activePage}
                    nextButton={this.nextButton}
                    backButton={this.backButton}
                    finishButton={(e) => this.finishButton(e)}
                />
            </Flex>
        );
    }
}

function mapStateToProps(state, ownProps)
{
    let itemId = state.getIn(['tutorial', 'currentItem']);
    let listId = state.getIn(['tutorial', 'currentList']);

    return {
        itemId: itemId,
        listId: listId
    };
}

export default connect(mapStateToProps)(Customization);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/Tutorial/Wizard/Customization.js